import { publicStorageUrl } from '@kit/shared/storage';

import { isBundledLandingImage } from '~/(tenant)/_lib/schema/landing-assets';

/** A builder upload's file name in home_assets, with an optional `?v=` cache-buster. */
export const HOME_ASSET_KEY = /^(?!\.{1,2}(?:\?|$))[\w.-]+(?:\?v=\d+)?$/;

/** The upload's file extension, or `jpg` when it has none usable in a key. */
export function homeAssetExtension(fileName: string): string {
  const dot = fileName.lastIndexOf('.');
  const ext = dot === -1 ? '' : fileName.slice(dot + 1).toLowerCase();

  return /^[a-z0-9]{1,5}$/.test(ext) ? ext : 'jpg';
}

/** A stored builder image: an upload key or a bundled `/landing-pages/…` image. */
export function isHomeImageKey(key: string): boolean {
  return HOME_ASSET_KEY.test(key) || isBundledLandingImage(key);
}

/**
 * Public URL for a landing/native-home builder image. Keys are stored bare in
 * the builder JSON (`hero-0.jpg?v=…`); bundled `/landing-pages/…` paths pass
 * through. Anything else, or no configured storage host, yields no image.
 */
export function homeAssetUrl(accountId: string, key: unknown): string {
  if (typeof key !== 'string' || !isHomeImageKey(key)) return '';
  if (isBundledLandingImage(key)) return key;

  const ref = `home_assets/${accountId}/${key}`;
  const url = publicStorageUrl(ref);

  // Unresolved means no base or a bad account id; never emit a relative src.
  return url === ref ? '' : url;
}
